import { render, staticRenderFns } from "./AuthorityAuthorTable.vue?vue&type=template&id=bf818af4&"
import script from "./AuthorityAuthorTable.vue?vue&type=script&lang=ts&"
export * from "./AuthorityAuthorTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports